export default "__VITE_ASSET__adfa80dd__"